import React from 'react';

import type {
  CompletedCalculationTactic,
  LoadFlowScenarioResults
} from '../../overmind/calculation';
import type { LoadFlowSummary } from '../../overmind/calculation/derived-state/loadFlowSummary';
import type { NonEmptyArray } from '../LowVoltageCalculation/LoadFlowSummaryCalculationResults/LvLoadFlowSummaryCalculationResults';
import { LvLoadFlowSummaryCalculationResults } from '../LowVoltageCalculation/LoadFlowSummaryCalculationResults/LvLoadFlowSummaryCalculationResults';
import { MvLoadFlowSummaryCalculationResults } from '../MediumVoltageCalculation/LoadFlowSummaryCalculationResults';

type LoadFlowResultsProps = {
  loadFlowScenarios: CompletedCalculationTactic['calculationSetResult']['calculationScenarios']['loadFlow'];
  loadFlowSummary: LoadFlowSummary;
};

export function LoadFlowResults(props: LoadFlowResultsProps) {
  if (props.loadFlowSummary.type === 'MediumVoltage') {
    return (
      <MvLoadFlowSummaryCalculationResults
        loadFlowSummary={props.loadFlowSummary.value}
        loadFlowScenarios={
          props.loadFlowScenarios as unknown as NonEmptyArray<LoadFlowScenarioResults>
        }
      />
    );
  }
  if (props.loadFlowSummary.type === 'LowVoltage') {
    return (
      <LvLoadFlowSummaryCalculationResults
        loadFlowSummary={props.loadFlowSummary.value}
        loadFlowScenarios={
          props.loadFlowScenarios as unknown as NonEmptyArray<LoadFlowScenarioResults>
        }
      />
    );
  }
  return null;
}
